import { Stack, Typography, Container } from '@mui/material';
import HowItWorkCard from 'components/HowItWorkCard/HowItWorkCard';
import useDeviceDetect from 'hooks/useDeviceDetect';
import { useTranslation } from 'react-i18next';

const HowItWorksSection = () => {
    const { t } = useTranslation();
    const { isLargeDesktop } = useDeviceDetect();
    return (
        <Container
            sx={{
                '&.MuiContainer-root': {
                    px: { xs: '20px', lg: '40px' },
                },
            }}
        >
            <Stack id={'how_it_works'} direction={'column'} justifyContent={'center'} alignItems={'center'} sx={{ width: '100%', py: '80px' }}>
                <Typography component={'h2'} sx={{ fontSize: '38px', fontWeight: 700, alignSelf: 'start', mb: '30px', lineHeight: '1.1' }}>
                    {t('How it works')}
                </Typography>
                <Stack spacing={'20px'} direction={!isLargeDesktop ? 'column' : 'row'} justifyContent={'space-between'} alignItems={'center'} width={'100%'}>
                    <HowItWorkCard
                        title={t('HowItWorkCard_1_title')}
                        descriptions={[t('HowItWorkCard_1_desrc_p1'), t('HowItWorkCard_1_desrc_p2')]}
                        image={'/images/request_location.svg'}
                        sx={{ maxWidth: '350px' }}
                    ></HowItWorkCard>
                    <HowItWorkCard
                        title={t('HowItWorkCard_2_title')}
                        descriptions={[t('HowItWorkCard_2_desrc_p1'), t('HowItWorkCard_2_desrc_p2')]}
                        image={'/images/geo_location.svg'}
                        sx={{ maxWidth: '350px' }}
                    ></HowItWorkCard>
                    <HowItWorkCard
                        component="picture"
                        title={t('HowItWorkCard_3_title')}
                        descriptions={[t('HowItWorkCard_3_desrc_p1'), t('HowItWorkCard_3_desrc_p2')]}
                        sx={{ maxWidth: '350px' }}
                    >
                        <source srcSet="/images/displaying_location.webp" type="image/webp" />
                        <source srcSet="/images/displaying_location.png" />
                        <img src={'/images/displaying_location.png'} width="392" height="256" alt="Displaying Location" />
                    </HowItWorkCard>
                </Stack>
            </Stack>
        </Container>
    );
};

export default HowItWorksSection;
